import { Form } from "react-bootstrap";

const NinthStepMobile = ({nineStep, updateMultipleValues}) => {

    const handleChange = (e) => {
        const values = {...nineStep};
        
        values[e.target.id] = e.target.value;
        
        updateMultipleValues({nineStep: values});
    }
    return (
      <>
        <div className="first-step-mobile-main-container mx-auto position-relative"  onChange={(e) => handleChange(e)}>
        <div className="title mb-4">
            <h1 className="register-text" style={{fontSize: 24, marginBottom: 15}}>Final Question</h1>
            
            <Form.Group controlId="formRoleName">
                <Form.Label className="form-label-mobile">Are there any other personal thoughts and experiences as an exchange student you would like to share with us? *</Form.Label>
                <Form.Control
                    placeholder=""
                    // value={summary}
                    required
                    // onChange={(e) => setSummary(e.target.value)}
                    as={"textarea"}
                    id="general_thoughts"
                    value={nineStep?.general_thoughts}
                />
                <Form.Control.Feedback type="invalid">
                    Please provide a description.
                </Form.Control.Feedback>
            </Form.Group>
            {/* <Form.Group className="mb-3" controlId="formRoleName">
                <Form
                    onSubmit={(e) => console.log("handle submit")}
                    style={{fontSize: 16, textAlign: "left" }}
                >
                <Form.Check // prettier-ignore
                    type={"checkbox"}
                    id={`default-radio`}
                    label={`use of data agreement + link to privacy page (for GDPR 
                        compliance)`}
                    name="group2"
                />
                </Form>
                <Form.Control.Feedback type="invalid">
                    Please provide a title.
                </Form.Control.Feedback>
            </Form.Group> */}
        </div>
      </div>
      </>
    );
  };
  
  export default NinthStepMobile;
  